export class RITEL_INVESTOR {
    constructor(
        public INV_ID: number,
        public INV_NAME: string,
        public IDTY_NO: string,
        public SID: string,
        public BIRTH_PLACE: string,
        public BIRTH_DATE: Date,
        public SBIRTH_DATE: string,
        public ADDRESS: string,
        public PHONE_NO: string,
        public MOBILE_NO: string,
        public EMAIL: string,
        public CD_DISTRICT: string,
        public KOTA: string,
        public PROVINSI: string,
        public CD_ID_TYP: string,
        public CD_GENDER: string,
        public CD_PROFESSION: string,
        public CREATED_BY: number
    ) { }
}
export class SIMPLE_INVESTOR {
    constructor(
        public INV_ID: number,
        public INV_NAME: string,
        public IDTY_NO: string,
        public SID: string,
        public BIRTH_PLACE: string,
        public BIRTH_DATE: Date
    ) { }
}

export class ACCOUNTS_INVESTOR {
    constructor(
        public BID_ID: number,
        public IDTY_NO: string,
        public INV_ID: number,
        public INV_NAME: string,
        public SERIES_NAME: string,
        public SUBREG_NAME: string,
        public SEC_REK_NO: string,
        public BANK_REK_NO: string,
        public ALT_AMT: number,
        public BID_AMT: number,
        public STAT_ISSUE: string,
        public ATTACHMENT: string,
        public CHECKED: boolean,
        public BID_DATE: string,
        public SELLING_AGENT: string,
        public SID: string,
        public ACCT_ID: number,
        public ACCT_NAME: string,
        public ACCT_NO: string,
        public ISSUED_BY: number,
        public ISSUED_NAME: string,
        public ISSUED_TYP: string,
        public CREATED_BY: number,
        public PARTS: any,
        public SEC_ACCT_ID: number,
        public INV_ACCT_ID: number
    ) { }
}


// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/models/investor.ts